import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FileService } from 'app/modules/common/services/file.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AttributeExcelImportModel } from '../models/attribute-excel-import';
import { AttributeImportViewService } from '../services/attribute-import-view.service';
import { AttributeImportService } from '../services/attribute-import.service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-attribute-parameter',
    templateUrl: './attribute-parameter.component.html',
    styleUrls: ['./attribute-parameter.component.scss'],
    standalone: false
})
export class AttributeParameterComponent implements OnInit {

  @Input() appExcelColumnPanel: any;
  
  importExcel = new UntypedFormControl();
  primeraFila = new UntypedFormControl();
  columnaClave = new UntypedFormControl();
  eliminarExisitingAttributos = new UntypedFormControl();

  fileBase64Value: string;
  fileChosen = false;
  fileChosenName = '';
  file: any;
  public FileFormatEnum = FileFormatEnum;

  constructor(public dialog: MatDialog,  
    private sharedService: SharedService,
    public attributeImportService: AttributeImportService,
    public attributeImportViewService: AttributeImportViewService,
    private changeDetectorRef: ChangeDetectorRef,
    private fileService: FileService) { }

  ngOnInit() {
    this.setDefaultControlValues();
  }


  setDefaultControlValues(){
    this.primeraFila.setValue(2);
    this.columnaClave.setValue(1);
    this.eliminarExisitingAttributos.setValue(false);
  } 

  onFileChange(files: FileList) {
    this.fileChosen = files.length > 0;
    if (this.fileChosen) {
      this.fileChosenName = files[0].name;
    }
    if (files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    if (files.length) {
      this.file = "";
      this.fileBase64Value = "";
      this.readFile(files[0])
    }

  }
  private readFile(file) {
    let currentContext = this;
    let fileReader = new FileReader();
    fileReader.onload = function (event) {
      currentContext.file = file.name;
      currentContext.fileBase64Value = currentContext.fileService.arrayBufferToBase64(fileReader.result);
    }
    //if(currentContext.fileService.getFileExtention(file.type) == 'XLSX'){ 
      if (FileFormatEnum.AttributeImportControllerTS.includes(currentContext.fileService.getFileExtention(file.type))) { 
      fileReader.readAsArrayBuffer(file);
    }else{
      this.fileChosenName = "";
      this.sharedService.ShowSnackBar('Upload only excel file', 'Okay', 4000);
    }
  }

  getParamterControls(){    
    var model = new AttributeExcelImportModel();
    model.primeraFila = this.primeraFila.value;
    model.columnaClave = this.columnaClave.value; 
    model.eliminarExisitingAttributos = this.eliminarExisitingAttributos.value;    
    model.camposImportacion = this.appExcelColumnPanel.getselectedColumnsData();
    model.excelfile = this.fileBase64Value;
    return model;
  }

  setInvalidFormCOntrol(formControl: any){
   
    if(formControl == "primeraFila"){
      this.primeraFila.markAllAsTouched();
      this.primeraFila.setErrors({'incorrect': true});
    }
    if(formControl == "columnaClave"){
      this.columnaClave.markAllAsTouched();
      this.columnaClave.setErrors({'incorrect': true});
    } 
  }

}
